import { formatDistanceToNow, isToday, parseISO, format, isYesterday, differenceInDays } from "date-fns";
import { ptBR } from "date-fns/locale";

export const toLastSeen = (isoDate = '') => {
  const date = parseISO(isoDate);
  if (isToday(date))
    return 'visto por último às ' + format(date, 'HH:mm');
  else if (isYesterday(date))
    return 'visto por último ontem às ' + format(date, 'HH:mm');
  else if (differenceInDays(new Date(), date) >= 7)
    return 'visto por último há muito tempo atrás';
  else
    return 'visto por último há ' + formatDistanceToNow(date, {locale: ptBR}) + ' atrás';
};

export const createArrayWithLength = (length, initialValueFactory = (() => null)) => {
  const data = [];
  for (let i = 0; i < length; i++) {
    data.push(initialValueFactory(i));
  }
  return data;
}



// WEBPACK FOOTER //
// ./helpers.js